import { EditableFavoriteTypeEnum } from '@elearning-platform/api-types/enums';
import { StatusInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const addFavouriteItem: (type: EditableFavoriteTypeEnum, id: number) => Promise<StatusInterface> = (
  type: EditableFavoriteTypeEnum, id: number
): Promise<StatusInterface> => api.post(`v1/users/favorite/${type}/${id}`);

export const removeFavouriteItem: (type: EditableFavoriteTypeEnum, id: number) => Promise<StatusInterface> = (
  type: EditableFavoriteTypeEnum, id: number
): Promise<StatusInterface> => api.delete(`v1/users/favorite/${type}/${id}`);
